var n=function(E){return E.GT="gt",E.GTE="gte",E.LT="lt",E.LTE="lte",E.EQ="eq",E.NEQ="neq",E.LIKE="like",E}({});export{n as CrudWhereOperator};